/* tslint:disable:max-line-length */
/**
 * Reflex API
 * v1
 * undefined
 */

import { HttpClient, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import * as __model from '../model';

export interface FaillistParams {
  SearchTerm?: string;
  ScanUserName?: string;
  CheckUserName?: string;
  OrderColumns?: string[];
  /** format: int32 */
  PageIndex?: number;
  /** format: int32 */
  PageSize?: number;
  /** format: int32 */
  MaxPageSize?: number;
  SkipTotalItemCount?: boolean;
  /** format: int32 */
  ProjectId?: number;
}

export interface ExportParams {
  SearchTerm?: string;
  /** format: int32 */
  ProjectId?: number;
  TranslationLanguageCode?: string;
  ScanUserName?: string;
  CheckUserName?: string;
}

@Injectable()
export class FaillistService {
  constructor(private http: HttpClient) {}

  /**
   * Statisztikai adatok listázása
   * http://undefined/swagger/swagger-ui.html#!/Faillist/Get
   */
  faillist(params: FaillistParams): Observable<__model.ListFaillistResult> {
    const queryParamBase = {
      SearchTerm: params.SearchTerm,
      ScanUserName: params.ScanUserName,
      CheckUserName: params.CheckUserName,
      OrderColumns: params.OrderColumns,
      PageIndex: params.PageIndex,
      PageSize: params.PageSize,
      MaxPageSize: params.MaxPageSize,
      SkipTotalItemCount: params.SkipTotalItemCount,
      ProjectId: params.ProjectId,
    };

    let queryParams = new HttpParams();
    Object.entries(queryParamBase).forEach(([key, value]: [string, any]) => {
      if (value !== undefined) {
        if (typeof value === 'string') queryParams = queryParams.set(key, value);
        else if (Array.isArray(value)) value.forEach(v => queryParams = queryParams.append(key, v));
        else queryParams = queryParams.set(key, JSON.stringify(value));
      }
    });

    return this.http.get<__model.ListFaillistResult>(`/api/project/Faillist`, {params: queryParams});
  }

  /**
   * Statisztikai adatok exportálása
   * http://undefined/swagger/swagger-ui.html#!/Faillist/Export
   */
  export(params: ExportParams): Observable<string> {
    const queryParamBase = {
      SearchTerm: params.SearchTerm,
      ProjectId: params.ProjectId,
      TranslationLanguageCode: params.TranslationLanguageCode,
      ScanUserName: params.ScanUserName,
      CheckUserName: params.CheckUserName,
    };

    let queryParams = new HttpParams();
    Object.entries(queryParamBase).forEach(([key, value]: [string, any]) => {
      if (value !== undefined) {
        if (typeof value === 'string') queryParams = queryParams.set(key, value);
        else if (Array.isArray(value)) value.forEach(v => queryParams = queryParams.append(key, v));
        else queryParams = queryParams.set(key, JSON.stringify(value));
      }
    });

    return this.http.post<string>(`/api/project/Faillist/Export`, {}, {params: queryParams});
  }
}
